import React from 'react'
import './ModalPopup.css'

const ModalPopup = props => (
  <div className={`Modal Modal-popup Modal-${props.name}`}>
    <div className="Modal-content">
      {props.children}
    </div>
    <div className="Modal-underlay" />
    <div className="Modal-overlay" />
  </div>
)

export default ModalPopup


// WEBPACK FOOTER //
// ./src/components/modals/modal/templates/popup/ModalPopup.js